function Age() {
    return (
        <div>
            <div class="age">
                <div class="contianer">
                    <div class="row align-items-center text-center">
                        <div class="col-md-6">
                            <h2>Enter a new age <br></br> of web design</h2>
                            <p>This section is perfect for featuring some information about your application, why it was built, the problem it solves, or anything else! There's plenty of space for text here, so don't worry about writing too much.</p>
                        </div>
                        <div class="col-md-6">
                            <img src="/img/photo-1620207418302-439b387441b0.jpg" class="img-fluid" alt=""></img>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Age;